import { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';
import { useBudgetDetails } from '../providers/hooks/useBudgetDetails';
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  ChartOptions,
  ChartData,
  Filler
} from "chart.js";
import "chartjs-adapter-date-fns";

import { useGetRequestForSlipChart } from "../hooks/Request/useGetRequestForSlipChart";

ChartJS.register(CategoryScale, Filler, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);

interface ChartPoint {
  x: Date; 
  y: number;
}

const ChartPage = () => {

  const {chatData, setChartData, fetchChartData} = useGetRequestForSlipChart();
  const budgetDetails = useBudgetDetails();

  const currentYear = new Date().getFullYear();

  const minDate = new Date(currentYear+"-01-01");
  const maxDate = new Date(currentYear+"-12-31");

  const minAmount = 0;
  const maxAmount = budgetDetails?.yearlyBudget ? budgetDetails?.yearlyBudget : 0;

  let actualData: ChartPoint[] = [];
  let currentTotalAmount = 0;
  let totalSum = 0;
  let currentDate = "";
  
  actualData.push({x: minDate, y: 0});
  
  chatData.forEach(function(currentValue){
    
    currentTotalAmount = currentTotalAmount + parseFloat(currentValue.total_price);
    
    currentDate = currentValue.submitted_on;
  
    actualData.push({x: new Date(currentDate), y: parseFloat(currentTotalAmount.toFixed(2))});
  });
  
  const planData: ChartPoint[] = [];
  planData.push({ x: minDate,y: minAmount});
  planData.push({ x: maxDate,y: maxAmount});
 
  const data: ChartData<"line", ChartPoint[]> = {
    datasets: [
      {
        borderColor: "#fa6181",
        fill: true,
        label: "Actual Data",
        stepped:"before",
        data: actualData
      },
      {
        label: "Plan Data",
        data: planData,
        borderColor: "#3292d3",
        borderDash: [5,5], 
        fill: false
      }
    ],
  };
  
  const options: ChartOptions<"line"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Multi-Line Graph with Dates",
      },
    },
    scales: {
      x: {
        display: true,
        type: "time", // Must be explicitly "time"
        time: {
          displayFormats: {
            millisecond: 'MMM dd',
            second: 'MMM dd',
            minute: 'MMM dd',
            hour: 'MMM dd',
            day: 'MMM dd',
            week: 'MMM dd',
            month: 'MMM dd',
            quarter: 'MMM dd',
            year: 'MMM dd',
          }
        },
        title: {
          display: true,
          text: "Date",
        },
        min: minDate.toString(),
        max: maxDate.toString()
      },
      y: {
        min: minAmount,
        max: maxAmount,
        title: {
          display: true,
          text: "Amount",
        },
        ticks: {
          stepSize: (maxAmount / 10)
        }
      },
    },
  };
  
    return (
        <>
            <PageTitle title="OPS | Slip Chart" />
            <MainLayout>
                
                <div>
                    <Line data={data} options={options} />
                </div>

            </MainLayout>
        </>
    )
}

export default ChartPage;